import { AppSidebar } from "@/components/ui/AppSidebar"
import { SidebarProvider } from "@/components/ui/sidebar"
import { AuthContext } from "@/context/authContext"
import Navbar from "@/pages/admin/_components/Navbar"
import { useContext } from "react"
import { Navigate, Outlet } from "react-router-dom"

export default function AdminLayout() {

  const { currentUser } = useContext(AuthContext)

  if (!currentUser?.email.includes('@gcad')) return <Navigate to='/' />

  return (
    <div>
      <SidebarProvider style={{ "--sidebar-width": "20rem", "--sidebar-width-mobile": "20rem" } as React.CSSProperties}>
        <AppSidebar/>
        <main className="w-full px-3">
          <Navbar/>
          <div className="p-6">
            <Outlet />
          </div>
        </main>
      </SidebarProvider>
    </div>
  )
}
